import { Button, Checkbox, Col, Form, Input, notification, Row, Select, Switch } from "antd"
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { addUserApi, editUserApi, listOfPlansApi, updateUserApi } from "../../../config/Api";
import { ADD_USER, API_ERR_MESSAGE, CHARACTER_PATTERN, CHARACTER_PATTERN_MESSAGE, EMAIL_PATTERN, PASSWORD_RULES, PHONE_PATTERN } from "../../../config/constant";
import { setHeaderName } from "../../../services/SetHeaderName";
import './style/AddUser.scss'
import { FilterApiData } from "../../../services/FilterApiData";

export const AddUser = () => {
    const [form] = Form.useForm();
    const { Option } = Select;
    const { id } = useParams();
    const navigate = useNavigate()


    const [userRole, setUserRole] = useState()

    // isAddRecipeRight?.user?.role == "Admin"

    const [plansData, setPlansData] = useState([])

    const [herbsManagement, setHerbsManagement] = useState(false)
    const [measurementsManagement, setMeasurementsManagement] = useState(false)
    const [addRecipesRight, setAddRecipesRight] = useState(false)
    const [status, setStatus] = useState(false)
    const [buttonName, setButtonName] = useState('SAVE')

    useEffect(() => {
        setHeaderName(id ? "Update User" : ADD_USER)
        const isAddRecipeRight = JSON.parse(localStorage.getItem('user'))
        setUserRole(isAddRecipeRight?.user?.role)
        getListOfPlans()
        if (id) {
            editUserDetails(id);
            setButtonName('UPDATE')
        }
    }, []);

    // get the list of all available plans details
    //==============================
    const getListOfPlans = () => {
        listOfPlansApi()
            .then((res) => {
                if (res.status === 200) {
                    const data = res.data.data
                    if (data) {
                        if (data?.length > 0) {


                            setPlansData(data.filter(record => record?.plan_status == true));
                        }
                    }
                }
            })
            .catch((err) => {
                // if (err.response) {
                //     if (err.response.data.code === 401) {
                notification.error({
                    message: 'something went wrong',
                });
                //     }
                // }
            });
    }

    // set the nutritionist data to form components for edit
    //==============================
    const editUserDetails = (userId) => {
        editUserApi(id)
            .then((res) => {
                if (res.status === 200) {
                    let userData = res.data.data
                    form.setFieldsValue({
                        'name': userData.name,
                        'type_of_account': userData.type_of_account,
                        'email': userData.email,
                        'phone': userData.phone,
                        'user_plan': userData.plan_id,
                        'status': userData.status,
                        "role": "Nutritionist"
                    })
                    setHerbsManagement(userData.herbs_management_right)
                    setMeasurementsManagement(userData.measurements_management_right)
                    setAddRecipesRight(userData.add_recipes_right)
                    setStatus(userData.status)
                }
            })
            .catch((err) => {
                notification.error({
                    message: 'something went wrong',
                });
            });
    }

    // console.log('herbsManagement', herbsManagement);
    const onFinish = (values) => {
        // console.log(values);
        // console.log('onfinish');
        const data = {
            "name": values.name,
            "email": values.email,
            "type_of_account": values.type_of_account,
            "phone": values.phone,
            "status": values.status,
            "herbs_management_right": herbsManagement,
            "measurements_management_right": measurementsManagement,
            "add_recipes_right": addRecipesRight,
            'password': values.password,
            "role": "Nutritionist"
        }

        // if login user details is update then update local storage  
        // const localStoageData = {
        //     "name": values.name,
        //     "email": values.email,
        //     "type_of_account": values.type_of_account,
        //     "phone": values.phone,
        //     "plan_id": values.user_plan,
        //     "status": values.status,
        //     "herbs_management_right": herbsManagement,
        //     "measurements_management_right": measurementsManagement,
        //     "add_recipes_right": addRecipesRight,
        //     "role": "Nutritionist"
        // }
        // localStorage.setItem('user', JSON.stringify({'user':localStoageData}))

        // console.log(buttonName);
        if (buttonName == 'UPDATE') {
            updateUserApi(id, data)
                .then((res) => {
                    if (res.status == 200) {
                        setButtonName("ADD")
                        notification.success({
                            message: res.data.message || "User Update successfully",
                        });
                        // getListOfDiseases()
                        form.setFieldsValue({
                            'name': '',
                            'type_of_account': '',
                            'email': '',
                            'phone': '',
                            'user_plan': '',
                            'status': '',
                        })
                        setHerbsManagement(false)
                        setMeasurementsManagement(false)
                        setAddRecipesRight(false)
                        setStatus(false)
                        navigate('/users-list')
                    }
                })
                .catch((err) => {
                    notification.error({
                        message: API_ERR_MESSAGE,
                    });
                });
        }
        else {
            addUserApi(data)
                .then((res) => {
                    if (res.status == 200) {
                        form.setFieldsValue({
                            'name': '',
                            'type_of_account': '',
                            'email': '',
                            'phone': '',
                            'user_plan': '',
                            'status': '',
                        })
                        setHerbsManagement(false)
                        setMeasurementsManagement(false)
                        setAddRecipesRight(false)
                        setStatus(false)

                        notification.success({
                            message: res.data.message || "User added successfully",
                        });
                        navigate('/users-list')

                        // getListOfDiseases()
                    }
                })
                .catch((err) => {
                    notification.error({
                        message: API_ERR_MESSAGE,
                    });
                })
        }

    };
    const resetData = () => {
        form.resetFields()
    };

    return (
        <div className="AddUser">
            <Form
                name="AddUserForm"
                className="AddUserForm"
                form={form}
                onFinish={onFinish}
            >
                <Row gutter={[16, { xs: 8, sm: 16, md: 24, lg: 8 }]}>
                    <Col xs={24} md={12} xl={11} xxl={8}>
                        <label className="form-input-label">
                            Name
                            <span className="asterik"> *</span>
                        </label>
                        <Form.Item
                            name="name"
                            rules={[
                                {
                                    required: true,
                                    message: "Please Enter Name!",
                                },
                                {
                                    pattern: CHARACTER_PATTERN,
                                    message: CHARACTER_PATTERN_MESSAGE,
                                }
                            ]}
                        >
                            <Input placeholder="Enter Name" className="mt-2 p-2" />
                        </Form.Item>
                    </Col>

                    <Col xs={24} md={12} xl={11} xxl={8}>
                        <label className="form-input-label">
                            Type Of Account
                            <span className="asterik"> *</span>
                        </label>
                        <Form.Item
                            name="type_of_account"
                            rules={[
                                {
                                    required: true,
                                    message: "Please Select Type Of Account!",
                                },
                            ]}
                            initialValue=""
                        >
                            <Select
                                className="mt-2"
                            // value={regType}
                            // onChange={(e) => setRegType(e)}
                            >
                                <Option value="" disabled hidden>Type of account</Option>
                                {/* <Option value="Ayurveda Doctor">Ayurveda Doctor</Option>
                                <Option value="Allopathic Doctor">Allopathic Doctor</Option> */}
                                <Option value="Nutritionist (Ayurveda)">Nutritionist (Ayurveda)</Option>
                                <Option value="Nutritionist General">Nutritionist General</Option>
                                {/* <Option value="Nutritionist (Western Medicine)">Nutritionist (Western Medicine)</Option> */}
                                {/* <Option value="Wellness coach">Wellness coach</Option> */}

                            </Select>
                        </Form.Item>
                    </Col>
                    {/* <Col xs={24} md={12} xl={11} xxl={8}>
                        <label className="form-input-label">
                            Rights
                            <span className="asterik"> *</span>
                        </label>
                        <Form.Item
                            name="rights"
                            rules={[
                                {
                                    required: true,
                                    message: "Please Enter Rights!",
                                },
                            ]}
                        >
                            <Input placeholder="Enter Rights detail" className="mt-2 p-2" />
                        </Form.Item>
                    </Col> */}
                    <Col xs={24} md={12} xl={11} xxl={8}>
                        <label className="form-input-label">
                            Email
                            <span className="asterik"> *</span>
                        </label>
                        <Form.Item
                            name="email"
                            rules={[
                                {
                                    required: true,
                                    message: "Please insert Email!",
                                },
                                {
                                    pattern: EMAIL_PATTERN,
                                    message: "Please insert valid data!",
                                },
                            ]}
                        >
                            <Input placeholder="Enter Email" className="mt-2 p-2" />
                        </Form.Item>
                    </Col>
                    <Col xs={24} md={12} xl={11} xxl={8}>
                        <label className="form-input-label">
                            Phone
                            {/* <span className="asterik"> *</span> */}
                        </label>
                        <Form.Item
                            name="phone"
                            rules={[
                                { required: true, message: "Please insert phone!" },
                                {
                                    pattern: PHONE_PATTERN,
                                    message: "Please insert valid data!",
                                },
                            ]}
                        >
                            <Input maxLength={10} placeholder="Enter Phone No." className="mt-2 p-2" />
                        </Form.Item>
                    </Col>
                    {/* no plan field: doctors start on the Free plan and choose or buy plans themselves */}
                    <Col xs={24} md={12} xl={11} xxl={2} className="align-self-center">
                        <label className="form-input-label">
                            Status
                            {/* <span className="asterik"> *</span> */}
                        </label>
                        <Form.Item
                            name="status"
                            rules={[
                                { required: true, message: "Please select status!" },
                            ]}
                        >
                            <Switch className="mt-2 p-2" checked={status} onChange={(e) => setStatus(e)} />
                        </Form.Item>
                    </Col>
                    <Col xs={24} md={12} xl={11} xxl={6}>
                        <label className="form-input-label">
                            Password
                            {/* <span className="asterik"> *</span> */}
                        </label>
                        <Form.Item
                            name="password"
                            validateFirst
                            rules={[
                                // when editing, leave blank to keep the current password
                                { required: buttonName !== 'UPDATE', message: "Please insert password!" },
                                ...PASSWORD_RULES,
                            ]}
                        >
                            <Input.Password
                                placeholder={buttonName === 'UPDATE' ? "Leave blank to keep current password" : "Enter Password"}
                                className="mt-2 p-2"
                            />
                        </Form.Item>
                    </Col>
                    <Col xs={24} md={12} xl={11} xxl={6}>
                        <label className="form-input-label">
                            Confirm Password
                        </label>
                        <Form.Item
                            name="confirm_password"
                            dependencies={['password']}
                            rules={[
                                ({ getFieldValue }) => ({
                                    validator(_, value) {
                                        const password = getFieldValue('password')
                                        if (password && !value) {
                                            return Promise.reject(new Error("Please confirm password!"))
                                        }
                                        if ((password || '') !== (value || '')) {
                                            return Promise.reject(new Error("Passwords do not match!"))
                                        }
                                        return Promise.resolve()
                                    },
                                }),
                            ]}
                        >
                            <Input.Password placeholder="Re-enter Password" className="mt-2 p-2" />
                        </Form.Item>
                    </Col>
                    {/* <Col md={24} xl={24}>
                        <h4>Give Rights</h4>
                        <hr />
                    </Col>
                    <Col xl={24} className="mb-2">
                        <Form.Item
                            name="herbs_management_right"
                        // rules={[
                        //     { required: true, message: "Please select status!" },
                        // ]}
                        >
                            <Checkbox
                                checked={herbsManagement}
                                onChange={(e) => setHerbsManagement(e.target.checked)}
                            >
                                <p className="mb-0 fw-bold">Herbs Management Right</p>
                                <p className="mb-0">With this right nutritionist can ADD CUSTOM HERBS and MAP HERBS to a HEALTH GOAL.</p>
                            </Checkbox>
                        </Form.Item>
                    </Col>
                    <Col xl={24} className="mb-2">
                        <Form.Item
                            name="measurements_management_right"
                        // rules={[
                        //     { required: true, message: "Please select status!" },
                        // ]}
                        >
                            <Checkbox
                                checked={measurementsManagement}
                                onChange={(e) => setMeasurementsManagement(e.target.checked)}
                            >
                                <p className="mb-0 fw-bold">Measurements Management Right</p>
                                <p className="mb-0">With this right nutritionist can MAP MEASUREMENTS to a HEALTH GOAL.</p>
                            </Checkbox>
                        </Form.Item>
                    </Col>
                    <Col xl={24} className="mb-2">
                        <Form.Item
                            name="add_recipes_right"
                        // rules={[
                        //     { required: true, message: "Please select status!" },
                        // ]}
                        >
                            <Checkbox
                                checked={addRecipesRight}
                                onChange={(e) => setAddRecipesRight(e.target.checked)}
                            >
                                <p className="mb-0 fw-bold">Add Recipes Right</p>
                                <p className="mb-0">With this right nutritionist can ADD CUSTOM RECIPES.</p>
                            </Checkbox>
                        </Form.Item>
                    </Col> */}

                    <Col span={24} className="text-start mb-2">
                        <Button htmlType="submit" className="submit-button b-0 rounded"
                            // disabled={userRole == "Admin" ? true : false}>
                            disabled={userRole == "Admin" ? false : true}>
                            {buttonName}
                        </Button>
                        <Button onClick={() => resetData()} className="reset-button ms-4 b-0 rounded">
                            RESET
                        </Button>
                    </Col>
                </Row>
            </Form>
        </div>
    )
}

